const idMessages = {
  "chat.end": "Mulai ulang percakapan obrolan Anda",
  "chat.endall": "Akhiri Obrolan",
  "chat.cancel": "Membatalkan",
  "chat.cookie":
    "Asisten digital ini menggunakan cookie untuk memastikan Anda mendapatkan pengalaman terbaik",
  "chat.learn": "Belajarlah lagi",
  "chat.minimize": "Memperkecil",
  "chat.hide": "Menutup",
  "chat.hidebot.text": "Tutup akan membuat avatar menghilang selama 15 menit",
  "chat.hidebot": "Tutup Bot",
  "chat.restart": "Mengulang kembali",
  "switch.language": "Ganti Bahasa",
  "switch.property": "Beralih Properti",
  "restart.converstation": "Mulai ulang Percakapan",
  "chat.endtext": "Apakah Anda yakin ingin mengakhiri obrolan saat ini?",
  "check.availabity": "Cek ketersediaan",
  "check.availabity.submit": "Kirim",
  "check.availabity.cancel": "Membatalkan",
  "check.availabity.adults": "Dewasa ",
  "check.availabity.children": "Anak-anak",
  "check.availabity.child.age": "Usia - Anak",
  "feedback.leave": "Tinggalkan umpan balik",
  "feedback.leave.message": "Tinggalkan pesan",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "Kirim Kasus",
  "caseform.system": "Sistem",
  "caseform.loading.systems": "Memuat sistem...",
  "caseform.select.system": "Pilih Sistem",
  "caseform.error.systems": "Kesalahan memuat sistem",
  "caseform.scenario": "Skenario",
  "caseform.loading.scenarios": "Memuat skenario...",
  "caseform.select.scenario": "Pilih Skenario",
  "caseform.error.scenarios": "Kesalahan memuat skenario",
  "caseform.topic": "Topik",
  "caseform.loading.topics": "Memuat topik...",
  "caseform.select.topic": "Pilih Topik",
  "caseform.error.topics": "Kesalahan memuat topik",
  "caseform.productArea": "Product Areas",
  "caseform.loading.productAreas": "Loading product areas...",
  "caseform.select.productArea": "Select Product Area",
  "caseform.error.productAreas": "Error loading product areas",
  "caseform.module": "Modules",
  "caseform.loading.modules": "Loading modules...",
  "caseform.select.module": "Select Module",
  "caseform.error.modules": "Error loading modules",
  "caseform.feature": "Features",
  "caseform.loading.features": "Loading features...",
  "caseform.select.feature": "Select Feature",
  "caseform.error.features": "Error loading features",
  "caseform.subject": "Subjek",
  "caseform.description": "Deskripsi",
  "caseform.attachments": "Lampiran",
  "caseform.attachments.remove": "Hapus",
  "caseform.submit": "Kirim",
  "caseform.cancel": "Batalkan",
  "caseform.success.title": "Kasus Dibuat",
  "caseform.success.message": "Kasus Anda telah berhasil dibuat.",
  "caseform.success.caseNumber": "Nomor Kasus:",
  "caseform.success.transferToLiveAgent":
    "Anda sedang dialihkan ke agen langsung.",
  "caseform.success.newChatWindowRightSide":
    "Jendela chat baru akan terbuka di sisi kanan browser Anda.",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Pilih Tindakan",
  "simpleaction.body":
    "Silakan pilih salah satu opsi berikut:{br}{b}Buat Kasus{/b} untuk mengirim permintaan dukungan, atau {b}Mulai Obrolan{/b} untuk terhubung dengan agen sekarang.",
  "simpleaction.startchat": "Mulai Obrolan",
  "simpleaction.createcase": "Buat Kasus",
  "caseform.error.generic": "Kesalahan dalam pembuatan kasus.",
  "caseform.error.generic.message":
    "Terjadi kesalahan saat membuat kasus Anda. Silakan coba lagi nanti.",
};
export default idMessages;
